import { Controller } from "@hotwired/stimulus"
import "intl-tel-input/build/css/intlTelInput.css"

export default class extends Controller {
  static values = { countryCode: String }
  static targets = ["input"]

  connect() {
    import("intl-tel-input").then(({ default: intlTelInput }) => {
      this.telInput = intlTelInput(this.inputTarget, {
        allowDropdown: true,
        initialCountry: this.countryCodeValue,
        nationalMode: true,
        hiddenInput: (telInputName) => ({
          phone: `${this.inputTarget.name.slice(0,-1)}_internationalized]`,
        }),
        loadUtils: () =>
          import(/* webpackIgnore: true */ "https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.0/build/js/utils.js")
      })
    })
  }

  disconnect() {
    if (this.telInput) {
      this.telInput.destroy();
    }
  }

  validate() {
    if (this.telInput && !this.telInput.isValidNumber()) {
      this.inputTarget.setCustomValidity("Please enter a valid phone number.");
    } else {
      this.inputTarget.setCustomValidity("");
    }
  }
}
